import React from 'react';
import VerificationForm from './VerificationForm';

const Index = ({ passport }) => {
  return passport.actions.verification ? <VerificationForm passport={passport} /> : null
}

export default Index;